/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".product-grid-tile[_ngcontent-%COMP%]{width:100%}.loading[_ngcontent-%COMP%]{position:absolute;height:100%;width:100%;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;-webkit-box-align:center;-ms-flex-align:center;align-items:center}"];
export { styles as styles };



// WEBPACK FOOTER //
// ./src/app/products/products.component.scss.shim.ngstyle.js.pre-build-optimizer.js